// deps
import React from "react";
import cx from "classnames";
import styles from "../CartGroup.scss";

export default function CartGroupContainer(props: {
    children: React.ReactNode;
    className?: string;
}): React.ReactElement {
    const groupClassName = cx(styles.cartGroup, props.className);

    return <div className={groupClassName}>{props.children}</div>;
}
